import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Heading } from '../common/heading';
import axios from 'axios';
import usePosts from '../hook/usePosts';
import PostTwo from '../components/post-two';

const PAGE_NUMBER = 1;

const InfinityScrollTwo = () => {
	const [pageNum, setPageNum] = useState(1);
	const { isLoading, isError, error, results, hasNextPage } = usePosts(pageNum);

	const intObserver = useRef<any>();
	const lastPostRef = useCallback(
		(post) => {
			if (isLoading) return;

			if (intObserver.current) intObserver.current.disconnect();

			intObserver.current = new IntersectionObserver((posts: any[]) => {
				if (posts[0].isIntersecting && hasNextPage) {
					console.log('We are near the last post!');
					setPageNum((prev) => prev + 1);
				}
			});

			if (post) intObserver.current.observe(post);
		},
		[isLoading, hasNextPage],
	);

	if (isError) return <p className="center">Error: {error.message}</p>;

	const content = results.map((post, i) => {
		if (results.length === i + 1) {
			return (
				<PostTwo
					ref={lastPostRef}
					key={post.id}
					post={post}
				/>
			);
		}
		return (
			<PostTwo
				key={post.id}
				post={post}
			/>
		);
	});

	return (
		<div>
			<Heading text="Infinity Scroll Two" />
			{content}
			{isLoading && <p className="center">Loading More Posts...</p>}
		</div>
	);
};

export default InfinityScrollTwo;
